const noneAuthPages = [
  "/login",
  "/login-internal",
  "/login-external",
  "/login-external/mfa",
  "/login-external/forgot-password",
  "/login-external/reset-password",
  "/login-external/expired-password",
  "/login-external/personal-details",
];

export default noneAuthPages;
